import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class TwoColumnLayoutService {
   private selectedIdSubject = new BehaviorSubject<number | null>(null);

   private newItemCreated = new BehaviorSubject<number | null>(null);

   private changesToNotify = new BehaviorSubject<boolean>(false);

   private firstIdInList = new BehaviorSubject<number | null>(null);

   private shouldShowDetailView = new BehaviorSubject<boolean>(false);

   private _deleteSchedule = new Subject<number>();

   private _deleteCallCost = new Subject<number>();

   private _deleteDepartment = new Subject<number>();

   private _renameDepartment = new Subject<number>();

   private _deactivateDepartment = new Subject<number>();

   private _mergeDepartment = new Subject<number>();

   private _untagDepartment = new Subject<number>();

   selectedId$ = this.selectedIdSubject.asObservable();

   newItemId$ = this.newItemCreated.asObservable();

   firstItemId$ = this.firstIdInList.asObservable();

   changesToNotify$ = this.changesToNotify.asObservable();

   shouldShowDetailView$ = this.shouldShowDetailView.asObservable();

   deleteSchedule$ = this._deleteSchedule.asObservable();

   deleteCallCost$ = this._deleteCallCost.asObservable();

   deleteDepartment$ = this._deleteDepartment.asObservable();

   renameDepartment$ = this._renameDepartment.asObservable();

   deactivateDepartment$ = this._deactivateDepartment.asObservable();

   mergeDepartment$ = this._mergeDepartment.asObservable();

   untagDepartment$ = this._untagDepartment.asObservable();

   emitDeleteSchedule(id: number) {
      this._deleteSchedule.next(id);
   }

   emitDeleteCallCost(id: number) {
      this._deleteCallCost.next(id);
   }

   emitDeleteDepartment(id: number) {
      this._deleteDepartment.next(id);
   }

   emitRenameDepartment(id: number) {
      this._renameDepartment.next(id);
   }

   emitDeactivateDepartment(id: number) {
      this._deactivateDepartment.next(id);
   }

   emitMergeDepartment(id: number) {
      this._mergeDepartment.next(id);
   }

   emitUntagDepartment(id: number) {
      this._untagDepartment.next(id);
   }

   setSelectedId(id: number | null) {
      this.selectedIdSubject.next(id);
      this.setShouldShowDetailView(id !== null);
   }

   getSelectedId(): number | null {
      return this.selectedIdSubject.getValue();
   }

   setFirstItemId(id: number | null) {
      this.firstIdInList.next(id);
   }

   getFirstItemId(): number | null {
      return this.firstIdInList.getValue();
   }

   setShouldShowDetailView(shouldShow: boolean) {
      this.shouldShowDetailView.next(shouldShow);
   }

   getShouldShowDetailView(): boolean {
      return this.shouldShowDetailView.getValue();
   }

   setNewItemCreated(id: number | null) {
      this.newItemCreated.next(id);
   }

   newItemAdded(id: number): void {
      this.setNewItemCreated(id);
      this.setSelectedId(id);
      this.notifyItemAddedOrDeleted();
   }

   notifyItemAddedOrDeleted(): void {
      this.changesToNotify.next(true);
   }

   itemDeleted(): void {
      this.notifyItemAddedOrDeleted();
      this.setSelectedId(null);
   }
}
